// extracted by mini-css-extract-plugin
export default {"main":"BodyDog_main__kbIEj","copyright":"BodyDog_copyright__IHNjt"};